import { getVersionForClone } from '@qr-front/ui/utils'

import { BaseUrlScreenBackground } from './BaseUrlScreenbackground'
import { Clone1UrlScreenBackground } from './Clone1UrlScreenBackground'

const UrlScreenBackground = getVersionForClone({
	base: BaseUrlScreenBackground,
	clone1: Clone1UrlScreenBackground,
})

export { UrlScreenBackground }
